import { useQuery } from '@tanstack/react-query'
import { fetchMyHouseholds } from '@/api/households'

// See useCurrentUser.ts — same reasoning, this also runs unconditionally via
// CurrentHouseholdProvider on public pages where there's no signed-in user yet.
export function useMyHouseholds() {
  return useQuery({
    queryKey: ['myHouseholds'],
    queryFn: fetchMyHouseholds,
  })
}
